import React from "react";
import LoginPage from "../component/LoginPage.jsx";

const Login = () => (
  <div>
    <LoginPage />
  </div>
);

export default Login;
